import { getJson } from './getJson';
import type { Categories } from './types';

export const getCategoriesFromJson = () => {
  return getJson<Categories>('/articles/categories.json');
};